var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wheel-home-game" },
    [
      _c("HomeGameWheel", { attrs: { game: _vm.wheelGame } }),
      !_vm.isSm
        ? _c("HomeGameCharacter", {
            attrs: {
              "assets-dir": "/static/wheel/",
              status: _vm.gameStatus,
              "start-at": _vm.wheelGame ? _vm.wheelGame.startAt : null,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }